<template>
  <div class="main">
    <div class="row infos">
      <div class="col-xl-4 col-lg-12">
        <div class="blc-dados">
          <img src="/img/icon-grups.png" alt="icone prospect">
          <p>List Prospects</p>
        </div>
      </div>
    </div>

    <div class="fundo">
      <div class="blc-inf-geral">
        <div class="blc-item">
          <div class="row">
            <div class="col-md-6 col-12">
              <h2>Prospects</h2>
            </div>
            <div class="col-md-6 col-12 txt-right">
              <button class="submit-verde" @click="cleanFiltros()">Clear Filters <img src="/img/icon-filter.png"></button>
              <button class="submit" @click="$router.push('/prospects/adicionar')">New Prospect +</button>
            </div>
          </div>

          <form @submit.prevent="listar()">
            <div class="row">
              <div class="mrg-top-30 col-lg-4 col-md-6 col-12">
                <base-input label="Title" placeholder="Search by title" v-model.lazy="search.title" />
              </div>
              <div class="mrg-top-30 col-lg-4 col-md-6 col-12">
                <base-input label="Vessel Name" placeholder="Search by vessel" v-model.lazy="search.navio_name" />
              </div>
              <div class="mrg-top-30 col-lg-4 col-md-12 col-12">
                <button style="margin-top: 32px;" class="submit w-100" :disabled="loading" @click="listar()">
                  <i class="fa fa-spinner fa-spin" v-if="loading" /> Search
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="blc-tabela tabela-listagem scroll" style="overflow: visible;">
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Vessel (Navio)</th>
                <th>Owner (Created by)</th>
                <th>Status</th>
                <th>Created in</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in list" :key="row.id">
                <td>{{ row.title }}</td>
                <td>{{ row.navio ? row.navio.name : '-' }}</td>
                <td>{{ row.user ? row.user.name : '-' }}</td>
                <td>
                  <span :class="row.status ? 'text-success' : 'text-danger'">
                    {{ row.status ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td>{{ row.created_at | date }}</td>
                <td class="text-right">
                  <base-dropdown class="dropdown" position="right" direction="up">
                    <a slot="title" class="btn btn-sm btn-icon-only" role="button">
                      <i class="fas fa-ellipsis-v"></i>
                    </a>
                    <template>
                      <a class="dropdown-item" href="#" @click.prevent="openViewModal(row)">
                        <i class="fas fa-users"></i> View Customers
                      </a>
                      
                      <router-link class="dropdown-item" :to="'/prospects/editar/' + row.id">
                        <i class="fas fa-edit"></i> edit
                      </router-link>

                      <a class="dropdown-item" href="#" @click.prevent="$root.openExcluirModal(
                        row, 'Delete prospect ' + row.title + '?', Service
                      )">
                        <i class="fas fa-trash"></i> delete
                      </a>
                    </template>
                  </base-dropdown>
                </td>
              </tr>
              <tr v-if="!list.length && !loading">
                <td colspan="100" style="text-align: center">No prospects found</td>
              </tr>
              <tr v-if="list.length <= 0 && loading">
                <td colspan="100" style="text-align: center">
                  <i class="fa fa-spinner fa-spin"></i>
                  Loading prospects...
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <base-pagination :pagination="pagination" @change="listar()" align="center" />

    <modal :show.sync="viewModal.show" modalClasses="modal-xl">
      <template slot="header">
        <h5 class="modal-title">Customers Linked to: {{ viewModal.prospectTitle }}</h5>
      </template>
      <div class="table-responsive">
        <table class="table table-flush">
          <thead class="thead-light">
            <tr>
              <th>Name</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cp in viewModal.customers" :key="cp.id">
              <td>{{ cp.customer ? cp.customer.name : 'N/A' }}</td>
              <td>{{ cp.customer ? cp.customer.email : 'N/A' }}</td>
            </tr>
            <tr v-if="!viewModal.customers.length">
              <td colspan="2" class="text-center">No customers linked to this prospect.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template slot="footer">
        <button class="btn btn-secondary" @click="viewModal.show = false">Close</button>
      </template>
    </modal>

    <excluir-modal
      :show="$root.modal.excluir.isOpen"
      :mensagem="$root.modal.excluir.mensagem"
      :model="$root.modal.excluir.model"
      :service="$root.modal.excluir.service"
      @close="handleExcluir"
    />
  </div>
</template>

<script>
import Service from "@/services/Prospects"; // Certifique-se que aponta para Prospects
import Modal from "@/components/Modal/Modal";

export default {
  components: { Modal },
  data() {
    return {
      Service,
      loading: false,
      list: [],
      pagination: {
        page: 1,
        last_page: 1,
        per_page: 20,
        total: 1
      },
      search: {
        title: '',
        navio_name: '',
      },
      defaultSearch: {},
      // Modal de Visualização
      viewModal: {
        show: false,
        prospectTitle: '',
        customers: []
      },
      orderBy: {
        campo: "data",
        ordem: "desc",
      },
    };
  },
  created() {
    this.defaultSearch = { ...this.search };
    this.listar();
  },
  methods: {
    listar() {
      this.loading = true;

      const params = {
        ...this.orderBy,
        with: ['navio', 'user', 'customerProspect.customer'],
        page: this.pagination.page,
        ...this.search
      };

      Service.get(params).then(response => {
        // Ajuste conforme a estrutura do seu retorno (data.data ou apenas data)
        const res = response.data.data ? response.data : { data: response.data };
        this.list = res.data;
        this.pagination.last_page = res.last_page || 1;
        this.pagination.total = res.total || res.data.length;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    openViewModal(prospect) {
      this.viewModal.prospectTitle = prospect.title;
      // Pegamos a relação que vem do back-end
      this.viewModal.customers = prospect.customer_prospect || [];
      this.viewModal.show = true;
    },

    handleExcluir(updated) {
      this.$root.modal.excluir.isOpen = false;
      if (updated) this.listar();
    },

    cleanFiltros() {
      this.search = { ...this.defaultSearch };
      this.pagination.page = 1;
      this.listar();
    }
  }
};
</script>

<style>
.modal-xl{
  max-width: 50% !important;
}

@media screen and (max-width: 1500px) {
  .modal-xl {
    max-width: 70% !important;
  }
  
}

@media screen and (max-width: 1200px) {
  .modal-xl {
    max-width: 90% !important;
  }
  
}

@media screen and (max-width: 600px) {
  .modal-xl {
    max-width: 100% !important;
  }
  
}
</style>